<template>
  <div class="themeDetails-view">
    <div class="menu">
      <menu-list></menu-list>
    </div>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home/theme' }">主题</el-breadcrumb-item>
        <el-breadcrumb-item>{{text}}</el-breadcrumb-item>
      </el-breadcrumb>
      <ul class="data-list">
        <li v-for="(item, index) in dataList" :key="index">
          <div class="left">
            <img :src="item.imgUrl" alt="">
          </div>
          <div class="right">
            <div class="name">{{item.name}}</div>
            <p class="p-money">
              ￥{{item.promotionPrice ? item.promotionPrice : item.money}}
              <span v-show="item.promotionPrice ? true : false">
                定价:￥{{item.money}}
              </span>
            </p>
            <p class="p-eBookPrice">
              <span v-show="item.eBookPrice">
                电子书:￥
                {{item.paperPromotionPrice ? item.paperPromotionPrice : item.eBookPrice}}
                <span style="text-decoration: line-through" v-show="item.paperPromotionPrice">
                  定价:{{item.eBookPrice}}
                </span>
              </span>
            </p>
            <p class="p-eBookPrice">
              {{item.author}}
            </p>
            <el-rate
              class="star"
              v-model="item.star"
              disabled
              show-score
              text-color="red"
              score-template="{value}颗星">
            </el-rate>
            <div class="d-describe">
              {{item.describe}}
            </div>
            <p class="p-btns">
              <button @click="trialReading(item)">在线试读</button>
              <img
                @click="shoppingCart(item)"
                :src="item.isGwc ? gwc2 : gwc1"
                alt=""
                :class="item.isGwc ? 'imgActive' : ''">
              <img @click="collection(item)" :src="item.isSc ? star2 : star1" alt="">
            </p>
          </div>
        </li>
      </ul>
      <div class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Menu from '@/base/menu/menu'
export default {
  name: '',
  components: {
    'menu-list': Menu
  },
  data () {
    return {
      gwc1: require('@/assets/images/fl/gwc1.png'),
      gwc2: require('@/assets/images/fl/gwc2.png'),
      star1: require('@/assets/images/fl/star1.png'),
      star2: require('@/assets/images/fl/star2.png'),
      currentPage: 1,
      pageSize: 10,
      total: 0,
      subjectId: '',
      text: '',
      dataList: []
    }
  },
  methods: {
    getSubjectBooks (start) { // 获取书局列表
      const userId = this.$store.state.userMsg.id
      const pageSize = this.pageSize
      const subjectId = this.subjectId
      const par = userId ? `?start=${start}&num=${pageSize}&subjectId=${subjectId}&userId=${userId}` : `?start=${start}&num=${pageSize}&subjectId=${subjectId}`
      this.$get(this.$allUrl.getSubjectBooks + par).then(res => {
        if (res.code === '0') {
          const list = res.data
          this.total = res.recordsTotal // 总条数
          this.dataList = []
          const imgAdmin = this.$allUrl.imgAdmin
          list.forEach(e => {
            this.dataList.push({
              id: e.bookId,
              imgUrl: imgAdmin + e.coverUrl,
              name: e.bookName,
              money: e.paperPrice, // 价格
              promotionPrice: e.promotionPrice,
              eBookPrice: e.emark === 0 ? '' : e.bookPrice, // 电子书价格
              author: e.bookAuthors,
              star: e.starLevel,
              describe: e.bookSummary,
              isSc: e.favorite !== null,
              isGwc: false,
              paperPromotionPrice: e.paperPromotionPrice
            })
          })
        }
      })
    },
    handleCurrentChange (val) {
      const start = (val - 1) * this.pageSize
      this.getSubjectBooks(start)
    },
    trialReading (item) { // 在线试读
      if (item.eBookPrice) {
        let routeData = this.$router.resolve({
          name: 'Book',
          query: {
            bookId: item.id,
            type: 1
          }
        })
        window.open(routeData.href, '_blank')
      } else {
        alert('该书籍没有电子书')
      }
    },
    shoppingCart (item) { // 购物车
      const state = item.isGwc
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        if (!state) {
          const bookId = item.id
          const par = `?bookId=${bookId}&userId=${userId}&type=0`
          const bookPrice = item.eBookPrice
          this.$get(this.$allUrl.addCart + par).then(res => {
            if (res.code === '0') {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              item.isGwc = true
              this.$root.eventHub.$emit('update_shoppingNum')
            } else {
              this.$message.error('添加失败')
            }
          })
          if (bookPrice) {
            const par2 = `?bookId=${bookId}&userId=${userId}&type=1`
            this.$get(this.$allUrl.addCart + par2).then(res => {
              if (res.code !== '0') {
                this.$message.error('电子书加入购物车失败')
              } else {
                this.$root.eventHub.$emit('update_shoppingNum')
              }
            })
          }
        }
      }
    },
    collection (item) { // 收藏
      const userId = this.$store.state.userMsg.id
      if (!userId) {
        this.$router.push({
          name: 'Login'
        })
      } else {
        if (!item.isSc) {
          const bookId = item.id
          const par = `?bookId=${bookId}&userId=${userId}`
          this.$get(this.$allUrl.addFavorite + par).then(res => {
            if (res.code === '0') {
              this.$notify({
                title: '成功',
                message: '已成功收藏',
                type: 'success',
                showClose: false,
                duration: 1500
              })
              item.isSc = true
            } else {
              this.$message.error(res.message)
            }
          })
        }
      }
    }
  },
  mounted () {
    this.subjectId = this.$route.query.subjectId
    this.text = this.$route.query.text
    this.getSubjectBooks(0)
  }
}
</script>
<style lang="less" scoped>
  .themeDetails-view{
    .menu{
      margin: 20px auto;
      width: 600px;
    }
    .content{
      padding: 0 10px 50px 10px;
      .pagination{
        text-align: right;
        padding: 50px 0 0 0;
      }
      .data-list{
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-wrap: wrap;
        li{
          flex: 1;
          min-width: 45%;
          max-width: 50%;
          border-bottom: 1px solid #DDDDDD;
          display: flex;
          .left{
            padding: 20px;
            img{
              display: block;
              width: 139px;
              height: 196px;
            }
          }
          .right{
            flex: 1;
            padding: 20px 20px 20px 0;
            overflow: hidden;
            font-size: 16px;
            p{
              margin: 0;
              padding: 0;
              margin-top: 10px;
            }
            .name{
              color: #35353b;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-weight: 600;
            }
            .p-money{
              color: #de0024;
              font-weight: 600;
              span{
                font-weight: 200;
                text-decoration: line-through;
                color: #a2a2a2;
                font-size: 12px;
              }
            }
            .p-eBookPrice{
              color: #a2a2a2;
              height: 19px;
              font-size: 14px;
            }
            .star{
              margin-top: 10px;
            }
            .d-describe{
              font-size: 14px;
              margin-top: 10px;
              height: 37px;
              overflow: hidden;
              word-break: break-all;
              display: -moz-box;
              -moz-box-orient:vertical;
              display: -webkit-box;
              -webkit-box-orient:vertical;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2;
            }
            .p-btns{
              vertical-align: middle;
              button{
                width: 100px;
                height: 28px;
                background-color: #B7151E;
                color: white;
                outline: none;
                border: 0;
                border-radius: 6px;
                cursor: pointer;
                float: left;
              }
              img{
                padding: 0 10px;
                cursor: pointer;
              }
              .imgActive{
                cursor: auto;
              }
            }
          }
        }
      }
    }
  }
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #B7151E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Theme/themeDetails.vue


// WEBPACK FOOTER //
// src/components/Theme/themeDetails.vue